import React from 'react';
import styled from 'styled-components';
import {Default,Mobile,CreateQuizSize} from '../Sizes';

const style = {
	Outline : styled.div`
		margin-top :2rem;
		display : flex;
		justify-content: space-around;
	`,
	Content : styled.div`
		background-color : transparent;
		border-radius : 5px;
		width : 80vw;
		height : 90vh;
		padding-bottom :2rem;
	`,
	mobile : {
		Wrapper : styled.div`
			width : 100%;
			height : ${CreateQuizSize.Height};
		`,
	}
};



export default function SingleContentLayout({render,...props}){
	return (
		<React.Fragment>
			<Default>
				<style.Outline {...props}>
					<style.Content>
						{render()}
					</style.Content>
				</style.Outline>
			</Default>
			<Mobile>
				<style.mobile.Wrapper>
					{render()}
				</style.mobile.Wrapper>
			</Mobile>
		</React.Fragment>
		
	);
}
